<template>
  <div id="div-search-bar">
    <b-row class="mt-3">
      <b-col cols="12">
          <b-input-group class="mb-2" v-b-toggle.sidebar-search @click.stop.prevent="search">
            <b-input-group-prepend>
                <b-button variant="secondary" size="sm"><b-icon icon="search"></b-icon></b-button>
            </b-input-group-prepend>
            <b-form-input
                id="searchDisplay"
                v-model="searchDisplay"
                type="text"
                :placeholder="model.label"
                readonly
                style='background-color: white;'
            ></b-form-input>
            <b-input-group-append v-if="haveFilter" @click.stop.prevent="remove">
                <b-button variant="danger" size="sm"><b-icon icon="x-square"></b-icon></b-button>
            </b-input-group-append>
          </b-input-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
'use strict'
/* eslint-disable */

import service from "@/service/service"
import utils from "@/utils/utils"
import EventBus from '@/plugins/eventbus'

// Embedded due to init.
// var data = {
//   debug: false,
//  };

export default {
  name: "SearchBar",
  data() {
    return {
      debug: false,
      model: {...this.value},
      searchDisplay: null
    };
  },
  props: {
    value: {  // from v-model on parent
      type: Object,
      default: {}
    }
  },
  computed: {
    haveFilter() {
      let aout = (this.model.catId !== null) || (this.model.compId !== null) || (this.model.query !== null)
      return aout
    }
  },
  // watch: {
  //   model: {
  //     deep: true,
  //     handler(modelArg) {  // receives updated this.model
  //       // console.log('searchBar watcher')
  //       // console.log(value)
  //       // Send updated model to parent.
  //       this.$emit('input', modelArg)  // send to listeners as input event
  //     }
  //   }
  // },
  methods: {
    search() {
      // console.log(`Clicked searchbar!`)
      // console.log(this.model)
      EventBus.$emit('search-sidebar', this.model)
    },
    remove() {
      this.model.catId = null
      this.model.compId = null
      this.model.query = null
      this.searchDisplay = null
      this.$root.setSearchDisplay(null)

      // console.log(`Clicked remove filter!`)
      this.$emit('remove-filter')
      // console.log(this.model)
      // this.$router.push({ path: this.model.path, query: {cid: '', coid: '', q: ''}})
    }
  },
  created() {
    // console.log(`Created: cid: ${this.cid}  q: ${this.q} `)
    this.model.path = this.model.path || '/search'
    this.model.catId = this.model.catId || null
    this.model.compId = this.model.compId || null
    this.model.query = utils.safeSearch(this.model.query)
    // if search parameters show "friendly" filter, else null
    // this.searchDisplay = (this.haveFilter) ? this.$root.getSearchDisplay() : null
    if (this.haveFilter) {
      this.searchDisplay = this.$root.getSearchDisplay()
      // console.log(`HaveFilter: ${this.searchDisplay}  String: ${utils.isString(this.searchDisplay)} `)
     }
     else {
      this.searchDisplay = null
      // console.log(`NO Filter: ${this.searchDisplay}  String: ${utils.isString(this.searchDisplay)} `)
     }

    // this.$root.setSearchModel(this.model)   // needed?
    // console.log(this.model)
  },
  mounted() {},
  beforeDestroy() {}
}
</script>

<style scoped>
#div-search-bar {
  /* border: 1px solid red; */
  background-color: #f3f4f9;
  margin: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/SearchBar.vue